import AuthCheck from "./auth-check";
import RenderAuthCheck from "./render-auth-check";

export default RenderAuthCheck(AuthCheck);  // TODO正式业务需要调整，只做演示
